

import React from 'react';

interface GraphControlsProps {
    filterType: 'all' | 'Исходящее' | 'Входящее';
    onFilterTypeChange: (type: 'all' | 'Исходящее' | 'Входящее') => void;
    connectedOnly: boolean;
    onConnectedOnlyChange: (value: boolean) => void;
    onOpenFilters: () => void;
    activeFiltersCount: number;
    metaMs?: number;
    counts: { nodes: number; edges: number };
    globalSearch: string;
    onGlobalSearchChange: (value: string) => void;
}

const GraphControls: React.FC<GraphControlsProps> = ({
    filterType,
    onFilterTypeChange,
    connectedOnly,
    onConnectedOnlyChange,
    onOpenFilters,
    activeFiltersCount,
    metaMs,
    counts,
    globalSearch,
    onGlobalSearchChange,
}) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
            {/* Фильтр по типу письма */}
            <label htmlFor="type-filter" style={{ fontSize: 13, color: '#374151' }}>Тип:</label>
            <select
                id="type-filter"
                aria-label="Фильтр по типу письма"
                value={filterType}
                onChange={(e) => onFilterTypeChange(e.target.value as 'all' | 'Исходящее' | 'Входящее')}
                style={{ padding: '6px 10px', border: '1px solid #ccc', borderRadius: 4, background: '#fff' }}
            >
                <option value="all">Все</option>
                <option value="Исходящее">Исходящее</option>
                <option value="Входящее">Входящее</option>
            </select>

            {/* Чекбокс "Только со связями" */}
            <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#374151' }}>
                <input 
                    type="checkbox" 
                    checked={connectedOnly} 
                    onChange={(e) => onConnectedOnlyChange(e.target.checked)} 
                />
                Только со связями
            </label>

            {/* Глобальный поиск */}
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <input
                    type="text"
                    value={globalSearch}
                    onChange={(e) => onGlobalSearchChange(e.target.value)}
                    placeholder="Поиск по письмам..."
                    style={{
                        padding: '6px 28px 6px 10px',
                        border: '1px solid #d1d5db',
                        borderRadius: 6,
                        fontSize: 13,
                        width: 220,
                        outline: 'none',
                    }}
                />
                {globalSearch && (
                    <button
                        onClick={() => onGlobalSearchChange('')}
                        style={{ position: 'absolute', right: 6, background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: 16, lineHeight: 1, padding: 0 }}
                        aria-label="Очистить поиск"
                    >
                        ×
                    </button>
                )}
            </div>

            {/* Кнопка открытия фильтров */}
            <button
                onClick={onOpenFilters}
                aria-label="Открыть фильтры"
                style={{ padding: '6px 10px', border: '1px solid #d1d5db', background: '#fff', borderRadius: 6, cursor: 'pointer' }}
            >
                Фильтры{activeFiltersCount ? ` (${activeFiltersCount})` : ''}
            </button>

            {/* Статистика графа */}
            <div style={{ fontSize: 12, color: '#6b7280' }}>
                {metaMs != null ? `Время генерации: ${metaMs} мс` : null}
                {`  Узлов: ${counts.nodes}  Связей: ${counts.edges}`}
            </div>
        </div>
    );
};

export default GraphControls;

